import { render, staticRenderFns } from "./tratamientoSesionNuevo.vue?vue&type=template&id=35aecea6&scoped=true"
import script from "./tratamientoSesionNuevo.vue?vue&type=script&lang=js"
export * from "./tratamientoSesionNuevo.vue?vue&type=script&lang=js"
import style0 from "./tratamientoSesionNuevo.vue?vue&type=style&index=0&id=35aecea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aecea6",
  null
  
)

export default component.exports